module.exports = "<!--<h1>{{this._appTitle}}</h1>-->\r\n<loading-container [loading]=\"this.loading\">\r\n    <content-list [startingNode]=\"0\" [isRoot]=\"true\" [catId]=\"this._catId\"></content-list>\r\n</loading-container>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/treeView.component.template.html
// module id = 300
// module chunks = 1